import { Box } from "@mui/material";
import { SingleMessageType } from "DataTypes/Chat.type";
import { FC } from "react";

export interface AudioComponentProps {
  message: SingleMessageType;
}

const AudioComponent: FC<AudioComponentProps> = (
  props: AudioComponentProps
) => {
  const { message } = props;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        padding: "4px 8px",
        borderRadius: "12px",
      }}
    >
      <audio
        controls
        style={{
          outline: "none",
          height: "32px",
          width: "200px",
        }}
      >
        <source src={message.attachmentUrl} type="audio/webm" />
        Your browser does not support the audio element.
      </audio>
    </Box>
  );
};

export default AudioComponent;
